const pages = {
    ADMIN_LICENSES: 'AdminLicenses',
    ADMIN_USERS: 'AdminUsers',
    PROFILE: 'Profile',
    SETTINGS: "Settings"
}

export default pages;
